module.exports = __webpack_public_path__ + "img/lieferando.d007642a.png";